import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Navbar from 'features/layout/components/navbarDesktop'
import MobileNavbar from 'features/layout/components/navbarMobile'
import CreateTaskButton from 'features/layout/components/createTaskButton'
import Popup from 'features/popup'
import { ProgressBar, Snackbar } from 'gipsy-ui'

const mapStateToProps = state => ({
  progressBarStatus: state.progressBar.status,
  sessionId: state.session.id
})

class Layout extends PureComponent {
  render() {
    const isConnected = !!this.props.sessionId
    const className = 'container' + (isConnected ? ' connected' : '')

    return (
      <div id="container" className={className}>
        {this.props.children}
        {isConnected && (
          <Fragment>
            <Navbar />
            <MobileNavbar />
            <CreateTaskButton />
          </Fragment>
        )}
        <ProgressBar status={this.props.progressBarStatus} intervalTime={600} />
        <Popup />
        <Snackbar.component />
      </div>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(Layout)
)



// WEBPACK FOOTER //
// ./src/features/layout/index.js